/**
 * 达人订单详情页 - 订单信息（图片、标签、信息网格、备注）
 */

import type { StaffOrderDetail } from "@/api/staff";

interface OrderInfoProps {
  data: StaffOrderDetail;
}

export default function OrderInfo({ data: d }: OrderInfoProps) {
  return (
    <>
      {/* 图片/头像 */}
      {d.staff_thumb ? (
        <div className="mx-4 mt-3 flex justify-center">
          <img
            src={d.staff_thumb}
            alt=""
            className="w-28 h-28 rounded-xl object-cover"
          />
        </div>
      ) : null}

      {/* 标签行 */}
      <div className="mx-4 mt-3 flex gap-2 flex-wrap">
        {d.num > 0 && (
          <span
            className="text-xs px-2.5 py-1 rounded-full font-medium"
            style={{ background: "#EEF2FF", color: "#6366F1" }}
          >
            {d.accept_order_type === 2 ? `${d.num}天` : `${d.num}${d.unit_name || "小时"}`}
          </span>
        )}
        <span
          className="text-xs px-2.5 py-1 rounded-full font-medium"
          style={{ background: "#ECFDF5", color: "#059669" }}
        >
          {d.travel_mode_title || "--"}
        </span>
        <span
          className="text-xs px-2.5 py-1 rounded-full font-medium"
          style={{ background: "#F0FDF4", color: "#16A34A" }}
        >
          {d.item_name || "达人服务"}
        </span>
      </div>

      {/* 标题 */}
      <div className="mx-4 mt-3">
        <h2 className="text-lg font-bold text-gray-900">
          {d.staff_name || "-"} · {d.city || ""}达人服务
        </h2>
      </div>

      {/* 信息网格 */}
      <InfoGrid data={d} />

      {/* 备注信息 */}
      {(d.remark || d.staff_remark) && (
        <div className="mx-4 mt-3 bg-white rounded-2xl p-4">
          <div className="flex items-center justify-between">
            <span className="text-sm font-bold text-gray-900">备注信息</span>
            <span className="text-sm" style={{ color: "#9CA3AF" }}>{d.remark || d.staff_remark || "无"}</span>
          </div>
        </div>
      )}
    </>
  );
}

/** 信息网格子组件 */
function InfoGrid({ data: d }: { data: StaffOrderDetail }) {
  return (
    <div className="mx-4 mt-3 bg-white rounded-2xl p-4">
      <div className="grid grid-cols-2 gap-y-4 gap-x-3">
        <InfoItem icon="ri-user-line" label="服务达人" value={d.staff_name || "-"} />
        <InfoItem icon="ri-phone-line" label="联系方式" value={d.link_mobile || "-"} />
        <InfoItem icon="ri-calendar-line" label="服务时间" value={d.book_time_desc || "-"} />
        <InfoItem
          icon="ri-time-line"
          label="服务时长"
          value={d.num > 0 ? (d.accept_order_type === 2 ? `${d.num}天` : `${d.num}${d.unit_name || "小时"}`) : "-"}
        />
        <InfoItem icon="ri-map-pin-line" label="服务地区" value={d.city || "-"} />
        <div className="col-span-2 flex items-start gap-2">
          <i className="ri-map-pin-2-line mt-0.5 flex-shrink-0" style={{ fontSize: 15, color: "#9CA3AF" }} />
          <div>
            <div className="text-xs mb-0.5" style={{ color: "#9CA3AF" }}>集合地点</div>
            <div className="text-sm font-semibold text-gray-900">{d.user_address || "-"}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

/** 单个信息项 */
function InfoItem({ icon, label, value }: { icon: string; label: string; value: string }) {
  return (
    <div className="flex items-start gap-2">
      <i className={`${icon} mt-0.5 flex-shrink-0`} style={{ fontSize: 15, color: "#9CA3AF" }} />
      <div>
        <div className="text-xs mb-0.5" style={{ color: "#9CA3AF" }}>{label}</div>
        <div className="text-sm font-semibold text-gray-900">{value}</div>
      </div>
    </div>
  );
}
